module.exports = __webpack_public_path__ + "static/media/flag_icon.9635ffcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/flag_icon.svg
// module id = 307
// module chunks = 2